import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton } from './AppStoreButton';
export function FooterCTA() {
  return <section className="bg-black py-24 px-6 flex flex-col items-center text-center" data-id="element-21">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-22">
        <h2 className="text-4xl md:text-5xl font-black tracking-tight text-white mb-10" data-id="element-23">
          Start your GLP-1 journey today
        </h2>

        <div className="mb-16" data-id="element-24">
          <AppStoreButton data-id="element-25" />
        </div>

        <div className="flex items-center gap-4 mb-4" data-id="element-26">
          <a href="https://go.pixo.co/glimo-terms" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-27">
            Terms
          </a>
          <span className="text-gray-600" data-id="element-28">·</span>
          <a href="https://go.pixo.co/glimo-privacy" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-29">
            Privacy
          </a>
        </div>

        <p className="text-gray-500 text-sm" data-id="element-30">
          © {new Date().getFullYear()} GLP-1 Tracker. All rights reserved.
        </p>
      </motion.div>
    </section>;
}